import { render, staticRenderFns } from "./OrderingSuccess.vue?vue&type=template&id=62084b4f&lang=pug&"
import script from "./OrderingSuccess.vue?vue&type=script&lang=js&"
export * from "./OrderingSuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports